// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DashboardTwoToneSvg from "@fishx/icons-svg/es/asn/DashboardTwoTone";
import FishxIcon from '../components/FishxIcon';

var DashboardTwoTone = function DashboardTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DashboardTwoToneSvg
  }));
};

DashboardTwoTone.displayName = 'DashboardTwoTone';
export default React.forwardRef(DashboardTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DashboardTwoTone.js
// module id = 2378
// module chunks = 0